import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const NoLayout = ({ children, scrollRef }) => {
  const classes = useStyles();

  return (
    <div className={classes.content} ref={scrollRef}>
      {children}
    </div>
  )
};

export default NoLayout;
